module.exports = __webpack_public_path__ + "static/img/manage1.da0fb938.png";